module.exports = __webpack_public_path__ + "static/media/Portrait-10271.fd6f1ffb.jpg";